<template>
  <div class="integrations-config font-inter pb-5">
    <div class="d-flex">
      <div class="flex-grow-1 bd-highlight">
        <BaseHeader :title="$t('views.seller.integrations.title')"></BaseHeader>
        <b-breadcrumb :items="breadcrumbItems" class="bg-white m-0 p-0"></b-breadcrumb>
      </div>
      <div class="align-content-center bd-highlight">
        <router-link to="/integracoes/logs-de-envio" class="btn-outline mt-4">{{ $t('views.seller.integrations.config.logs.button') }}</router-link>
      </div>
    </div>
    <div class="divider mt-3"></div>
    <div class="d-flex align-self-start">
      <div class="flex-grow-1 bd-highlight">
        <div class="form-integration">
          <h3 class="title-main">{{ $t('views.seller.integrations.config.title') }} {{ integration.name }}</h3>
          <p class="subtitle d-block mt-1">{{ $t('views.seller.integrations.config.subtitle') }}</p>

          <component 
            v-if="CreateComponent" 
            :is="CreateComponent" 
            ref="createComponentRef"

            :loading="loading"
            :loadingProducts="loadingProducts"

            :integration="integration"
            :products="products"
            :variable="variable"
            :events="events"
            :sugestionRedirect="sugestionRedirect"

            :mountInputError="mountInputError"
            :isInputError="isInputError"
            :removeError="removeError"
            :showError="showError"
            :selectAll="selectAll"
            :isOptionSelected="isOptionSelected"
            :limitText="limitText"
            :organizePayloadsByGroup="organizePayloadsByGroup"
            :organizeEvents="organizeEvents"
            :fetchCallbacks="fetchCallbacks"
            :updateCallbacks="updateCallbacks"
          />
       
        </div>
      </div>

      <!-- Lista os cards -->
      <div class="flex-grow-1 bd-highlight d-flex flex-column align-items-end pl-4">
        <b-skeleton-wrapper :loading="loadingGroupCallbacks" class="d-flex flex-column align-items-end w-100">
          <template #loading>
            <div v-for="s in 3" class="card-integration mb-2" :key="s">
              <b-skeleton class="my-2" width="55%"></b-skeleton>
              <b-skeleton class="mb-2" width="85%"></b-skeleton>
              <b-skeleton class="mb-2" width="70%"></b-skeleton>
              <b-skeleton class="mb-1" width="30%"></b-skeleton>
            </div>
          </template>
        </b-skeleton-wrapper>
        <component 
          v-if="ListComponent"
          :is="ListComponent"
          ref="listComponentRef"
          :loadingGroupCallbacks.sync="loadingGroupCallbacks"
          :integration="integration"
          :events="events"
          :showEditCallback="showEditCallback"
        />
      </div>
    </div>

    <!-- Janela de edição -->
    <b-sidebar class="side-edit font-inter " :visible="opendEdit" width="680px" @hidden="closeEdit" right backdrop>
      <b-overlay :show="editGroupLoad" rounded="sm">
        <component 
          v-if="UpdateComponent"
          :is="UpdateComponent"
          ref="updateComponentRef"
          :opendEdit.sync="opendEdit"
          :loadingUpdate.sync="loadingUpdate"
          :editGroupLoad.sync="editGroupLoad"
          
          :integration="integration"
          :products="products"
          :variable="variable"
          :events="events"
          :sugestionRedirect="sugestionRedirect"
          :productSelected.sync="productSelected"

          :mountInputError="mountInputError"
          :mountPayload="mountPayload"
          :isInputError="isInputError"
          :removeError="removeError"
          :removeErrors="removeErrors"
          :showError="showError"
          :limitText="limitText"
          :organizePayloadsByGroup="organizePayloadsByGroup"
          :organizeEvents="organizeEvents"
          :fetchCallbacks="fetchCallbacks"
          :isOptionSelected="isOptionSelected"
          :selectAll="selectAll"
        />
      </b-overlay>
      <template #footer="{ hide }">
        <div class="d-flex justify-content-end p-3">
          <b-button class="btn-cancel mr-3" variant="primary" @click="hide" :disabled="loadingUpdate">
            {{ $t('views.seller.integrations.config.edit.button.cancel') }}
          </b-button>
          <b-button class="btn-confirm" :disabled="editGroupLoad || loadingUpdate" @click="updateCallbacks([productSelected])">
            <template v-if="loadingUpdate">
              <b-spinner variant="light" class="mr-2" small></b-spinner>
              {{ $t('views.seller.integrations.config.edit.button.saving') }}
            </template>
            <template v-else>
              {{ $t('views.seller.integrations.config.edit.button.save') }}
            </template>
          </b-button>
        </div>
      </template>
    </b-sidebar>

  </div>
</template>

<script>

import ProductService from '@/services/resources/ProductService';
import CallbackService from '@/services/resources/CallbackService';

import { loadComponents } from "@/components/Seller/Integrations/configs/index";

export default {
  name: "IntegrationsConfig",
  data: () => {
    return {
      // Components
      CreateComponent: null,
      ListComponent: null,
      UpdateComponent: null,

      // Globals
      loading: true,
      integration: {
        name: 'Webhook'
      },
      products: {
        value: null,
        items: [
          {
            group: {
              name: '',
            },
            options: [],
          }
        ],
      },
      variable: {
        value: null,
        items: [],
      },
      events: {
        options_sales: [],
        options_contracts: [],
        options_sales_recovery: []
      },
      sugestionRedirect: {
        url: null,
        name: null,
      },
      inputErrors: {},

      // Create
      loadingProducts: false,

      // List
      loadingGroupCallbacks: true,

      // Update
      opendEdit: false,
      loadingUpdate: false,
      editGroupLoad: true,
      productSelected: null,
    }
  },
  computed: {
    breadcrumbItems() {
      return [
        { text: 'Dashboard', href: '/dashboard' },
        { text: this.$t('views.seller.integrations.title'), href: '/integracoes' },
        { text: `${this.$t('views.seller.integrations.config.title')} ${this.integration.name}` }
      ];
    },
  },
  async created() {
    this.initializeData();
    this.fetchIntegration(this.$route.params.integration);

    const components = await loadComponents(this.$route.params.integration);
    this.CreateComponent = components.create;
    this.ListComponent = components.list;
    this.UpdateComponent = components.update;
  },
  methods: {
    initializeData() {
      this.products.items[0].group.name = this.$t('views.seller.integrations.config.save.type');

      this.variable.items = this.translateVariables([{
        group: {
          id: "sale",
        },
        options: [
          {
            id: "sale.id",
            $isDisabled: true
          }, {
            id: "sale.status",
            $isDisabled: true
          }, {
            id: "sale.smart_sale",
          }, {
            id: "sale.method",
          }, {
            id: "sale.installments",
          }, {
            id: "sale.currency",
          }, {
            id: "sale.country",
          },
          // {
          //   id: "sale.exchange_rate",
          // },
          {
            id: "sale.current_charge",
          }, {
            id: "sale.amount",
          }, {
            id: "sale.fee",
          },
          // {
          //   id: "sale.fee_installments",
          // }, 
          {
            id: "sale.affiliate",
          },
          // {
          //   id: "sale.co_seller",
          // },
          {
            id: "sale.seller_balance",
          }, {
            id: "sale.available",
          },
          // {
          //   id: "sale.refunded_value",
          // },
          // {
          //   id: "sale.chargedback_value",
          // },
          {
            id: "sale.paid_at",
          }, {
            id: "sale.created_at",
          }, {
            id: "sale.coupon",
          }, {
            id: "sale.refused_reason",
          },
          // {
          //   id: "sale.refunded_reason",
          // },
          {
            id: "sale.boleto_url",
          }, {
            id: "sale.boleto_barcode",
          }, {
            id: "sale.boleto_expiration_date",
          }, {
            id: "sale.pix_key",
          },
          // {
          //   id: "sale.pix_expiration_date",
          // }, 
          // {
          //   id: "sale.order_bump_id",
          // }
        ]
      }, {
        group: {
          id: "client",
        },
        options: [
          {
            id: "client.id",
          }, {
            id: "client.name",
          }, {
            id: "client.email",
          }, {
            id: "client.cellphone",
          }, {
            id: "client.document",
          }, {
            id: "client.zipcode",
          }, {
            id: "client.street",
          }, {
            id: "client.number",
          }, {
            id: "client.complement",
          }, {
            id: "client.neighborhood",
          }, {
            id: "client.city",
          }, {
            id: "client.uf",
          }
        ]
      }, {
        group: {
          id: "product",
        },
        options: [
          {
            id: "product.id",
          }, {
            id: "product.name",
          }, {
            id: "product.offer_hash",
          }, {
            id: "product.offer_name",
          }, {
            id: "product.offer_price",
          }, {
            id: "product.description",
          }, {
            id: "product.thank_you_page",
          }, {
            id: "product.type",
          }, {
            id: "product.format",
          }, {
            id: "product.max_installments",
          }, {
            id: "product.garantee",
          }, {
            id: "product.period",
          }, {
            id: "product.trial",
          }, {
            id: "product.limit_charges",
          }, {
            id: "product.method",
          }, {
            id: "product.installments_credit_card",
          }, {
            id: "product.installments_boleto",
          }, {
            id: "product.affiliation_permission",
          }, {
            id: "product.affiliation_aproval",
          }, {
            id: "product.affiliation_comission",
          }, {
            id: "product.coupon",
          }, {
            id: "product.address",
          }, {
            id: "product.tax_category",
          }, {
            id: "product.service_code",
          },
          {
            id: "product.smart_sale",
          },
          {
            id: "product.is_smart_sale",
          },
        ]
      }, {
        group: {
          id: "contract",
        },
        options: [
          {
            id: "contract.id",
          }, {
            id: "contract.status",
          }, {
            id: "contract.change_subscription_url",
          }, {
            id: "contract.start_date",
          },
          // {
          //   id: "contract.next_date",
          // }, {
          //   id: "contract.suspension",
          // }
        ]
      }, {
        group: {
          id: "affiliate",
        },
        options: [
          {
            id: "affiliate.id",
          }, {
            id: "affiliate.name",
          }, {
            id: "affiliate.email",
          }
        ]
      }, {
        group: {
          id: "co_seller",
        },
        options: [
          {
            id: "co_seller.id",
          },
          {
            id: "co_seller.name",
          }, {
            id: "co_seller.email",
          }
        ]
        },
      //   {
      //   group: {
      //     id: "due_days",
      //   },
      //   options: [
      //     {
      //       id: "due_days.before",
      //     }, {
      //       id: "due_days.after",
      //     }
      //   ]
      // },
      // {
      //     group: {
      //         id: "contract_days",
      //     },
      //     options: [
      //         {
      //             id: "contract_days.before",
      //         }, {
      //             id: "contract_days.after",
      //         }
      //     ]
      // }, 
      {
        group: {
          id: "seller",
        },
        options: [
          {
            id: "seller.id",
          }, {
            id: "seller.name",
          }, {
            id: "seller.email",
          }, {
            id: "seller.cellphone",
          }
        ]
      }]);

      this.events.options_sales = this.translateEvents([
        {
          value: "salePaid",
        },
        {
          value: "saleRefused",
        },
        {
          value: "saleRefunded",
        },
        {
          value: "saleChargedback",
        },
        {
          value: "saleUnpaid",
        },
        {
          value: "saleWaitingPayment",
        },
      ]);

      this.events.options_contracts = this.translateEvents([
        {
          value: "contractUnpaid",
        },
        {
          value: "contractPaid",
        },
        {
          value: "contractTrialing",
        },
        {
          value: "contractPendingPayment",
        },
        {
          value: "contractEnded",
        },
        {
          value: "contractCanceled",
        },
      ]);

      this.events.options_sales_recovery = this.translateEvents([
        {
          value: "checkoutAbandoned",
        },
        {
          value: "saleDueDays",
          groups: [
            {
              label: this.$t('views.seller.integrations.config.events.days_before'),
              options: [
                {
                  value: 7,
                  text: `7 ${this.$t('views.seller.integrations.config.events.days')}`,
                },
                {
                  value: 5,
                  text: `5 ${this.$t('views.seller.integrations.config.events.days')}`,
                },
                {
                  value: 3,
                  text: `3 ${this.$t('views.seller.integrations.config.events.days')}`,
                },
                {
                  value: 2,
                  text: `2 ${this.$t('views.seller.integrations.config.events.days')}`,
                },
                {
                  value: 1,
                  text: `1 ${this.$t('views.seller.integrations.config.events.day')}`,
                },
                {
                  value: 0,
                  text: this.$t('views.seller.integrations.config.events.day_renovation'),
                }
              ]
            },
            {
              label: this.$t('views.seller.integrations.config.events.days_after'),
              options: [
                {
                  value: -1,
                  text: `1 ${this.$t('views.seller.integrations.config.events.day')}`,
                },
                {
                  value: -2,
                  text: `2 ${this.$t('views.seller.integrations.config.events.days')}`,
                },
                {
                  value: -3,
                  text: `3 ${this.$t('views.seller.integrations.config.events.days')}`,
                },
                {
                  value: -5,
                  text: `5 ${this.$t('views.seller.integrations.config.events.days')}`,
                },
                {
                  value: -7,
                  text: `7 ${this.$t('views.seller.integrations.config.events.days')}`,
                },
                {
                  value: -30,
                  text: `30 ${this.$t('views.seller.integrations.config.events.days')}`,
                }
              ]
            }
          ]
        }
      ]);
    },
    translateEvents(events) {
      return events.map(event => {
        event.text = this.$t(`views.seller.integrations.config.events.${event.value}`);
        return event;
      });
    },
    translateVariables(items) {
      return items.map(item => {
        item.group.name = this.$t(`views.seller.integrations.config.variables.${item.group.id}.group`);
        item.options = item.options.map(option => {
          option.name = this.$t(`views.seller.integrations.config.variables.${option.id}`);
          return option;
        });
        return item;
      });
    },
    limitText(count) {
      return `+ ${count}`
    },
    selectAll(type) {
      let object = this[type] || type || null;
      if (object?.value?.length > 0) {
        object.value = [];
      } else {
        let allOptions = [];
        object.items.forEach(item => {
          allOptions = allOptions.concat(item.options || item || []);
        });
        object.value = allOptions;
      }
    },
    isOptionSelected(type, option, force, obj) {
      let object = obj || this[type];
      return object?.value?.find(item => item.id === option) || force
        ? require('@/assets/img/icons/checkbox-area-selected.svg')
        : require('@/assets/img/icons/checkbox-area.svg');
    },
    fetchIntegration(integration) {
      this.loading = true;
      CallbackService.build().read(`integrations/${integration}`)
      .then(response => {
        this.integration = response;
        this.loading = false;
        this.fetchProducts();
      })
      .catch(() => {
        this.$router.push('/integracoes');
      });
    },
    fetchProducts() {
      this.products.items[0].options = [];
      ProductService.build().search({
        list: true
      })
      .then(response => {
        for (let element of response) {
          this.loadingProducts = false;
          this.products.items[0].options.push({
            id: element.id,
            name: element.name
          });
        }
      })
      .catch(err => {
        this.loadingProducts = false;
      });
    },
    organizeEvents(events) {

      if(!events) return [];

      return events.map(event => {
        const transformedEvent = { trigger: event.value };
        
        if (event.sub) {
          transformedEvent.sub_trigger = event.sub.map(subEvent => subEvent.value);
        }
        
        return transformedEvent;
      });
    },
    organizePayloadsByGroup(payloads) {

      if(!payloads) return [];

      return payloads.reduce((acc, item) => {
        const [group, value] = item.split('.');
        
        if (!acc[group]) {
          acc[group] = [];
        }
        
        acc[group].push(value);
        
        return acc;
      }, {});
    },
    mountPayload(payloads) {
      const result = [];

      // Se nao for passado nenhum payload, seleciona todos
      if (!payloads) {
        this.variable.items.forEach(item => {
          result.push(...item.options);
        });
        return result;
      }

      // Intera sobre cada grupo em payloads
      for (const group in payloads) {
        payloads[group].forEach(payloadId => {
          // Encontra o grupo correspondente em variables.items
          const variableGroup = this.variable.items.find(item => item.group.id === group);
          if (variableGroup) {
            // Encontra a option correspondente no grupo
            const option = variableGroup.options.find(opt => opt.id === `${group}.${payloadId}`);
            if (option) {
              result.push(option);
            }
          }
        });
      }

      return result;
    }, 
    mountInputError(data, prefix = '') {
      var errors = {};

      this.sugestionRedirect = {
        url: null,
        name: null,
      };

      Object.keys(data).forEach(key => {
        const errorLabel = key.split('.')[0];
        const errorKey = `${prefix}${errorLabel}`;

        // verifica se o data[key][0] retornou no texto .. {{acaso|Acaso}}, pegar o valor entre {{}} com regex
        if (errorLabel === 'url' && data[key][0].includes('{{') && data[key][0].includes('}}')) {
          const matches = data[key][0].match(/{{(.*?)}}/g);
          if (matches) {
            const redir = (matches[0].replace(/{{|}}/g, '')).split('|');
            this.sugestionRedirect = {
              url: redir[0],
              name: redir[1]
            };

            errors[errorKey] = data[key][0].replace(matches[0], '');
          }
        }
        else {
          errors[errorKey] = data[key][0];
        }
      });
      
      this.inputErrors = errors;
    },
    isInputError(label) {
      return label in this.inputErrors ? 'input-error' : '';
    },
    showError(label) {
      return this.inputErrors[label] || '';
    },
    removeError(label) {
      if (label in this.inputErrors) {
        this.$delete(this.inputErrors, label);
      }
    },
    removeErrors(labels) {
      labels.forEach(label => {
        this.removeError(label);
      });
    },
    closeEdit() {
      this.opendEdit = false;
    },
    fetchCallbacks() {
      // Chama a função no componente list
      if (this.$refs.listComponentRef && this.$refs.listComponentRef.fetchCallbacks) {
        this.$refs.listComponentRef.fetchCallbacks();
      }
    },
    updateCallbacks(data) {
      // Chama a função no componente update
      if (this.$refs.updateComponentRef && this.$refs.updateComponentRef.updateCallbacks) {
        this.$refs.updateComponentRef.updateCallbacks(data);
      }
    },
    showEditCallback(data) {
      // Chama a função no componente update
      if (this.$refs.updateComponentRef && this.$refs.updateComponentRef.showEditCallback) {
        this.$refs.updateComponentRef.showEditCallback(data);
      }
    },
  }
}
</script>

<style lang="scss">
.integrations-config {

  .subtitle {
    color: #6B7280;

    strong {
      font-weight: 500;
      font-size: 16px;
    }
  }
  .subinfo {
    font-size: 12px
  }
  .copy {
    cursor: pointer;
  }

  .delete-link {
    font-family: "Inter", sans-serif; 
    position: relative;
    color: #EF4444;
    font-size: 12px;
    font-weight: 500;
    top: -8px;
  }

  .select-all {
    font-size: 12px;
    color: #949494;
    text-decoration: underline;
  }

  .form-integration {
    width: 100%;
    max-width: 690px;
  }

  .card-integration {
    position: relative;
    background: #F3F4F6;
    padding: 16px;
    border-radius: 8px;
    width: 100%;
    min-width: 530px;
    max-width: 640px;
    overflow: hidden;

    .product {
      font-weight: 600;
    }

    .url {
      font-size: 12px;
    }

    .actions {
      gap: 8px;

      .action_button {
        border: none;
        background: transparent;
        padding: 0;

        &__edit:hover svg path {
          fill: #0854C5;
        }
        &__delete:hover svg path {
          fill: #EF4444;
        }
      }
    }

    .items-list {
      .item-box {
        display: inline-block;
        margin: 0 3px 3px 0;

        span {
          background: #EEF2FF;
          border: 1px solid #2A63AB;
          padding: 2px 8px;
          border-radius: 50px;
          color: #0854C5;
          font-weight: 500;
          font-size: 12px;

          &.limit {
            background: #0854C5;
            color: #fff;
          }
        }
      }
    }
  }

  // Input e botoes
  .form-input,
  .form-input:focus {
    border: 1px solid #D1D5DB !important;
    box-shadow: 0 1px 2px 0 #0000000D;
    margin-top: 4px !important;
    height: 40px !important;
    padding: 0 10px !important;
  }
  .form-group {
    margin-bottom: 0;
  }

  .btn-send-test {
    margin-top: 4px;
    height: 40px;
    width: 126px;
  }

  // Switch form
  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #0854C5;
    border-color: #0854C5;
  }

  .form-input {
    font-family: "Inter", sans-serif; 
    &:disabled {
      background: #F3F4F6;
    }
  }

  // Errors
  .show-error {
    transition: all .2s ease;
    display: none;
    opacity: 0;
  }
  .input-error {
    .multiselect__tags,
    .form-input {
      border-color: #EF4444 !important;
    }
    .title-medium {
      color: #EF4444;
    }
    .show-error {
      color: #EF4444;
      margin-top: 4px;
      display: block;
      opacity: 1;
    }
  }
}

.optional {
  font-size: 12px;
  font-weight: 500;
}

// Sidebar
.side-edit { 
  position: relative;

  &-content {
    min-height: calc(100vh - 81px);
  }

  .b-sidebar-header {
    background: #fff;
    background: linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 80%);
    position: absolute;
    height: 70px;
    padding-top: 12px;
    inset: 0;
    bottom: auto;
    align-items: flex-start;
    z-index: 1;
  }

  .b-sidebar {
    background: #fff !important;
  }

  .b-sidebar-footer {
    border-top: 1px solid #D1D5DB;
  }
}
</style>